// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"36ad3f00","80":"ac651bde","187":"bc4faa57","585":"b7b919a7","622":"2fb938d3","683":"110ad9eb","684":"b7eeabcf","819":"36610bb5","958":"e98e85af"}[chunkId] + ".chunk.js";
};